import { Validators } from '@biteinc/common';
import type { Schema } from '@biteinc/common';
import { CountryCode } from '@biteinc/enums';

export const createSiteSchema: Schema.Model = {
  displayName: 'site',
  type: 'object',
  fields: {
    name: {
      type: 'keyString',
      required: true,
    },
    storeNumber: {
      type: 'keyString',
      displayName: 'Store Number',
      validationRegex: Validators.siteStoreNumberRegexString,
      tooltip: {
        text: 'Allowed characters: uppercase letters, numbers, and dashes.',
      },
    },
    biteOnly: {
      type: 'bool',
      displayName: 'Bite-Only',
      biteOnly: true,
    },
    countryCode: {
      displayName: 'Country',
      type: 'stringEnum',
      enum: CountryCode,
      required: true,
      ui: 'radiolist',
    },
    postalCode: {
      displayName: 'Postal Code',
      type: 'keyString',
      required: true,
      tooltip: {
        text: 'We will set the timezone from the postal code automatically.\nSample postal codes for specific time zones:\nUSA PT/MT/CT/ET: 90210/84150/40004/10118\nCanada BC/Alberta/ET/Atlantic: V6A 1Z7/T2P 1J9/M5C 1N7/B3H 4P7',
      },
    },
  },
};
